import React, { useRef } from 'react';
import classnames from 'classnames';

import { useDialogFocus } from '../../hooks/useDialogFocus';
import { useScrollLock } from '../../hooks/useScrollLock';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    closeButtonLabel: string;
    className?: string;
    children: React.ReactNode;
}

export const Drawer = ({ isOpen, onClose, title, closeButtonLabel, className, children }: Props) => {
    const panelRef = useRef<HTMLDivElement>(null);
    useDialogFocus(panelRef, isOpen);
    useScrollLock(isOpen);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Escape') {
            event.preventDefault();
            onClose();
        }
    };

    return (
        <div className={classnames('bs-drawer', className, { 'bs-drawer--open': isOpen })} onClick={onClose} aria-hidden={!isOpen}>
            <div
                className='bs-drawer__panel'
                role='dialog'
                aria-modal='true'
                aria-label={title}
                tabIndex={-1}
                ref={panelRef}
                onClick={e => e.stopPropagation()}
                onKeyDown={handleKeyDown}
            >
                <button className='bs-drawer__close' type='button' aria-label={closeButtonLabel} onClick={onClose}>
                    &times;
                </button>
                <h2 className='bs-drawer__title'>{title}</h2>
                {children}
            </div>
        </div>
    );
};
